<template>
  <live-map :tags="Tags" />
</template>

<script>
import { mapState, mapActions } from "vuex";
import LiveMap from "../leaflet/LiveMap.vue";
import { tagsWithAttributeDict } from "../../_helpers/tagHelper";

export default {
  name: "TagMap",

  data() {
    return {};
  },

  components: {
    LiveMap,
  },

  computed: {
    ...mapState("users", ["currentUser", "userCompany", "hasCompany"]),
    ...mapState("tag", { tags: "tagsWithInformation" }),

    Tags() {
      return tagsWithAttributeDict(this.tags);
    },
  },

  methods: {
    ...mapActions("tag", { getTags: "getTagsWithInformation" }),
  },

  created() {
    this.getTags();
  },
};
</script>
